import { Box, Skeleton, styled } from "@mui/material";
import React from "react";
import { MessageProps } from "../../../interfaces/all";
import { MessageContainer } from "./styles";

const ReactionBubble = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 24,
  minHeight: 24,
  padding: "2px 6px",
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
  border: "1px solid #e9edef",
  fontSize: "1.1rem",
  fontWeight: 400,
  userSelect: "none",
  zIndex: 2,
  marginTop: "-10px",
  marginLeft: "42px",
  cursor: "default",
  "&:hover": {
    background: "#f8f9fa",
  },
}));

interface ReactionMessagePropsSkeleton extends MessageProps {
  showSkeleton?: boolean;
}

const ReactionMessage: React.FC<ReactionMessagePropsSkeleton> = ({
  message,
  showSkeleton = false,
}) => {
  const isFromClient = message.sentBy === "client";

  if (showSkeleton) {
    return (
      <MessageContainer isFromClient={isFromClient} showTriangle={false}>
        <ReactionBubble>
          <Skeleton variant="circular" width={16} height={16} />
        </ReactionBubble>
      </MessageContainer>
    );
  }

  if (!message.content.reaction?.emoji) {
    return null;
  }

  return (
    <MessageContainer
      isFromClient={isFromClient}
      showTriangle={false}
      sx={{
        minHeight: "auto",
        padding: "0 16px",
        marginTop: "-8px", // Efeito de "grudar" na mensagem de cima
        marginBottom: "4px",
      }}
    >
      <ReactionBubble>{message.content.reaction.emoji}</ReactionBubble>
    </MessageContainer>
  );
};

export default ReactionMessage;
